export default __webpack_public_path__ + "static/media/peder-min.7843327d.png";